/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js'
import MapUtils from '@/utils/MapUtils.js'
import ConstUtils from '@/utils/ConstUtils.js'
import { useConnection } from '../../../v3/composables/useConnection'
import ComplianceOperations from '@/domain/model/compliance/ComplianceOperations.js'

const { log } = useConnection();

// The Compliance tables' replies carry each inspection cut down to the few fields the table
// draws. Kept out of the shared store: they would replace whole records that other screens and
// dialogs read from here. The Compliance page reads them from the reply itself.
const SUMMARY_EVENTS = [
  ComplianceOperations.List.Names.Notification,
  ComplianceOperations.VehicleList.Names.Notification,
];
const state = {
  list: [],
  map: {},
  total: 0,
  inspections_event: null,
  inspection_data: null,
}

const getters = {
  inspections_found: state => state,
  inspections_returned_event: state => state.inspections_event,
  inspection_data_event: state => state.inspection_data,
}

const actions = {
  InspectionsStore_clear({ commit }) {
    commit('clearInspections');
  }
}

const mutations = {
  clearInspections(state) {
    state.map = {};
    state.list = [];
  },
  SOCKET_ONMESSAGE(state, event) {
    if (SUMMARY_EVENTS.includes(event.eventName)) {
      return;
    }
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.VehicleInspectionMap) {
        var inspections = event.Payload.VehicleInspectionMap;

        state.map = MapUtils.updateMap(inspections, state.map);
        state.list = Object.values(state.map);
        
        if (event.Payload.count) {
          state.total = event.Payload.count;
        }
        log.info('Inspections: {0}', [state.list.length]);
      }
    }
    if (event.Payload && event.Payload.VehicleInspection) {
      var obj = event.Payload.VehicleInspection;
      state.map[obj[ConstUtils.FIELDS.ID]] = obj;
      state.list = Object.values(state.map);
      log.info('Inspections: {0}', [state.list.length]);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
